export function sanitizeRedirectPath(value?: string | null): string | null {
  if (!value) {
    return null;
  }
  if (!value.startsWith("/")) {
    return null;
  }
  if (value.startsWith("//")) {
    return null;
  }
  return value;
}

export function getNextPathFromSearch(search: string): string | null {
  if (!search) {
    return null;
  }
  const params = new URLSearchParams(search);
  const next = params.get("next");
  return sanitizeRedirectPath(next);
}
